module.exports = __webpack_public_path__ + "static/media/hsbc.757966cc.png";